/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S5_P1Inputs */

const en_guide_json_vs_yaml_xml_s5_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose the format based on your primary need:`)
};

const ko_guide_json_vs_yaml_xml_s5_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주요 필요에 따라 포맷을 선택하세요:`)
};

const ja_guide_json_vs_yaml_xml_s5_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主な用途に基づいてフォーマットを選択してください：`)
};

/**
* | output |
* | --- |
* | "Choose the format based on your primary need:" |
*
* @param {Guide_Json_Vs_Yaml_Xml_S5_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s5_p1 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S5_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S5_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s5_p1(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s5_p1(inputs)
	return ja_guide_json_vs_yaml_xml_s5_p1(inputs)
});